import { render } from "./CRMSystemPage.vue?vue&type=template&id=bad26704&ts=true"
import script from "./CRMSystemPage.vue?vue&type=script&lang=ts"
export * from "./CRMSystemPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__